import { ppAutocompleteMapper } from '../../common/autocomplete/utils/AutocompleteMapper';

import type { AutocompleteOption, AutocompleteResponse } from '../../types';

export const usePrepackageAutocompleteMapper = (lookupCount: (id: string) => number) => {
    return (response: AutocompleteResponse): AutocompleteOption[] =>
        ppAutocompleteMapper(response)
            .map((suggestion) => ({ ...suggestion, count: lookupCount(suggestion.id) }))
            .sort((a, b) => (a.count && b.count ? b.count - a.count : 0))
            .slice(0, 8);
};
